module.exports = __webpack_public_path__ + "img/ИФ-1(А)-020-m.d9c9aa99.png";